import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-app-wrapper',
  standalone: false,
  styleUrls: ['./app-wrapper.component.scss'],
  templateUrl: './app-wrapper.component.html'
})
export class AppWrapperComponent {}
